module.exports = __webpack_public_path__ + "img/crm_sales4.9d9ba8d4.png";